import React, { useEffect, useState } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Header from "../../Header";
import Sidebar from "../../Sidebar";

import { putInvoice } from "../../../connections/putInvoice";

const Edit_Invoices = () => {
  const [formState, setFormState] = useState({});
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const invoiceData = location.state || null;
  const {
    user: { user },
  } = useSelector((store) => store);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!invoiceData?.id) {
      toast.error("Invoice not found. Open the invoice from the list again.");
      return;
    }
    if (!formState.name?.trim()) {
      toast.error("Name is required");
      return;
    }
    if (!formState.mobile?.trim()) {
      toast.error("Mobile is required");
      return;
    }
    if (formState.age && isNaN(Number(formState.age))) {
      toast.error("Age must be a number");
      return;
    }

    // Only the patient details are editable - amounts, status, department and
    // the rest of the invoice must stay untouched
    const payload = {
      invoice: {
        name: formState.name?.trim(),
        age: formState.age,
        mobile: formState.mobile?.trim(),
      },
    };

    try {
      setSaving(true);
      const result = await putInvoice(user?.token, payload, invoiceData?.id);
      if (result?.status?.status === "SUCCESS") {
        toast.success("Invoice Updated Successfully");
        setFormState({});
        navigate(-1);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    if (invoiceData) {
      setFormState({
        name: invoiceData?.name ?? invoiceData?.patient?.full_name ?? "",
        age: invoiceData?.age ?? invoiceData?.patient?.age ?? "",
        mobile: invoiceData?.mobile ?? invoiceData?.patient?.mobile ?? "",
      });
    }
  }, [invoiceData]);

  return (
    <div>
      <Header />
      <Sidebar activeClassName="invoice-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={-1}>Invoice </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Update Invoice</li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      {invoiceData?.id}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page form */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Update Invoice</h4>
                            <p className="text-muted mb-0">
                              Only the patient name, age and mobile can be
                              changed here. Invoice amounts, status and
                              department stay as they are.
                            </p>
                          </div>
                        </div>

                        <div className="col-12 col-md-4 col-xl-3">
                          <div className="form-group local-forms">
                            <label>Invoice UID</label>
                            <input
                              value={invoiceData?.uid || ""}
                              className="form-control"
                              type="text"
                              readOnly
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-4 col-xl-3">
                          <div className="form-group local-forms">
                            <label>Status</label>
                            <input
                              value={invoiceData?.status || ""}
                              className="form-control"
                              type="text"
                              readOnly
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-4 col-xl-3">
                          <div className="form-group local-forms">
                            <label>Grand total</label>
                            <input
                              value={invoiceData?.grand_total ?? ""}
                              className="form-control"
                              type="text"
                              readOnly
                              disabled
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-4 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Name <span className="login-danger">*</span>
                            </label>
                            <input
                              value={formState?.name || ""}
                              name="name"
                              onChange={handleChange}
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-4 col-xl-3">
                          <div className="form-group local-forms">
                            <label>Age</label>
                            <input
                              value={formState?.age || ""}
                              name="age"
                              onChange={handleChange}
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-4 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Mobile
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              value={formState?.mobile || ""}
                              name="mobile"
                              onChange={handleChange}
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              onClick={handleSubmit}
                              type="submit"
                              disabled={saving}
                              className="btn btn-primary submit-form me-2"
                            >
                              {saving ? "Updating..." : "Update Invoice"}
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(-1);
                              }}
                              type="button"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Edit_Invoices;
